"use client";

import { useRouter } from "next/navigation";
import { LuChevronLeft } from "react-icons/lu";

import { DebugOG } from "@/components/shared/debug-og";
import { Button } from "@/components/ui/button";
import { useLayout } from "@/contexts/layout-context";
import { usePostContext } from "@/contexts/post-context";
import { APP_ROUTES } from "@/utils/constants";
import { getUserName } from "@/utils/usernames";

export const PostHeader = () => {
  const router = useRouter();
  const { poster, isReply } = usePostContext();
  const { history } = useLayout();

  const label = isReply ? "Comment by" : "Post by";

  return (
    <div className="unforce-radius relative border-b border-border">
      <div className="flex w-full items-center justify-between p-2">
        <div className="flex items-center gap-4">
          <Button
            size="icon"
            variant="outline"
            onClick={() => {
              if (history.length > 1) {
                router.back();
              } else {
                router.push(APP_ROUTES.app);
              }
            }}
          >
            <LuChevronLeft className="text-lg" />
          </Button>
          <span className="font-sans font-medium text-muted">
            {label}{" "}
            {getUserName({
              account: poster,
            })}
          </span>
        </div>
      </div>
      <DebugOG />
    </div>
  );
};
